import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import tbkApi from '../../services/tbkApi';
import { propTypes, defaultProps, mapStateToProps, mapDispatchToProps } from './App.props';
import Products from '../Products';
import { SET_APP_DATA } from './App.actions';
import Reduxify from '../../services/ReduxifyController';

class App extends Component {

	static propTypes = propTypes;
	static defaultProps = defaultProps;
	static mapStateToProps = mapStateToProps;
	static mapDispatchToProps = mapDispatchToProps;

	constructor(props) {
		super(props);
		tbkApi.prepare().then(() => {
			const match = document.body.className.match(/page-id-([0-9]+)/);
			let args = {};
			if ( match ) {
				args.page = match[1];
			}
			tbkApi.getAppAssets(args).then(data => {
				this.props.dispatch({
					type: SET_APP_DATA,
					assets: data.assets
				});
			});
		}).catch(e => {
			// Things is bad, we can't call the API, wonder what we should do?
			tbkApi.logger(e);
		});
	}

	render() {
		const { assets } = this.props;

		if (!assets) {
			return "loading";
		} else {
			return <div className="app clearfix">
				<div id="app__main" className="app__main">
					<section className="app__main__body">
						<Switch>
							<Route component={Products} />
						</Switch>
					</section>
				</div>
			</div>;
		}
	}
}

export default Reduxify(App);



// WEBPACK FOOTER //
// ./src/containers/App/App.js